module.exports = __webpack_public_path__ + "static/media/screenshot1.fbc94a1a.png";